import { render, staticRenderFns } from "./NotificationInfo.vue?vue&type=template&id=b900d50a&scoped=true&"
import script from "./NotificationInfo.vue?vue&type=script&lang=js&"
export * from "./NotificationInfo.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInfo.vue?vue&type=style&index=0&id=b900d50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b900d50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b900d50a')) {
      api.createRecord('b900d50a', component.options)
    } else {
      api.reload('b900d50a', component.options)
    }
    module.hot.accept("./NotificationInfo.vue?vue&type=template&id=b900d50a&scoped=true&", function () {
      api.rerender('b900d50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/NotificationInfo.vue"
export default component.exports